import { render, staticRenderFns } from "./LgFinderPageTipoLocalArmazenamento.vue?vue&type=template&id=49ce1298"
import script from "./LgFinderPageTipoLocalArmazenamento.vue?vue&type=script&lang=js"
export * from "./LgFinderPageTipoLocalArmazenamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports